import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import HealthPlanProvidersTable from "../../uis/planProvidersTable/approvedTable";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useDispatch } from "react-redux";
import { fetchProviders } from "../../../store/planProviders";
import ReusableModal from "../../uis/modals/ReusableModal";
import Button from "../../common/Button";

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
const HealthPlanProviders = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    mode: null,
    providerData: null,
  });
 
  const dispatch = useDispatch();


  const handleCreatePlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.post(`/v1/admin/providers`, data);
      console.log("Health Plan Provider created successfully:", response.data);
      dispatch(fetchProviders(10, 1)); // Refresh table
    } catch (error) {
      console.error("Error creating health plan provider:", error);
      throw error; // Let modal handle error
    }
  };

  const handleEditPlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.put(`/v1/admin/providers/${id}`, data);
      console.log("Health Plan Provider updated successfully:", response.data);
      dispatch(fetchProviders(10, 1)); // Refresh table
    } catch (error) {
      console.error("Error updating health plan provider:", error);
      throw error; // Let modal handle error
    }
  };

  const openModal = (mode, providerData) => {
    setModalConfig({
      isOpen: true,
      mode,
      providerData,
    });
  };

  const closeModal = () => {
    setModalConfig({ isOpen: false, mode: null, providerData: null });
  };

  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <Button onClick={() => openModal("create", {})}> Create Provider</Button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <HealthPlanProvidersTable
              openModal={openModal}
              closeModal={closeModal}
            />
          </div>
          <ReusableModal
            isOpen={modalConfig.isOpen}
            onClose={closeModal}
            mode={modalConfig.mode}
            providerData={modalConfig.providerData}
            onSubmit={
              modalConfig.mode === "create"
                ? handleCreatePlanProvider
                : handleEditPlanProvider
            }
          />
        </div>
      </div>
    </>
  );
};

export default HealthPlanProviders;
